import React, { useState, useEffect } from "react";
import Translations from '../../services/translation.service';
import StorefrontTitle from "../shared/storefront-title.component";
import BillPaymentAccountRow from "./components/bill-payment-account-row";
import CommonPayment from "../shared/commonPayments/common-payment-index";
import Storage from "../../services/storage.service";
import CONSTANTS from "../../services/constants.service";
import Helpers from "../../helpers/shared.helper";
import "moment/locale/ar-sa";
import "moment/locale/en-ca";
import FirebaseAnalytics from "../../services/analytics.service";

const subscriptions = [];
const BillPaymentAccounts = (props) => {
    const [selectedAccounts, setSelectedAccounts] = useState([]);
    const [showPayment, setShowPayment] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    const [apiResponse, setApiResponse] = useState([]);
    const [isPayDisabled, setIsPayDisabled] = useState(true);
    const { history } = props;
    const [translationKeys, setTranslationsKeys] = useState(
        Translations.keys ? Translations.keys : {}
    );

    const [tapPayload, setTapPayload] = useState({
      paymentData: {
        // number: null,
        // amount: 30,
        bill_payment_data: [
          { 
            amount: 0, 
            number: null, 
            invoice_no: null,
            contract_number: null 
          }
        ]
      },
      apiEndpoint: {
        endpoint: "/terminated_customer/online_bills_payment",
        // endpoint: "/postpaid_bills/pay_with_new_card_web",
        method: "post"
      },
      extraInformation: {
        totalAmount: 0,
        payingFor: "bill_payment",
        showAppDownloads: true,
        showPaymentLogos: true
      }
    });
    

    // Prepare Data for Apple Pay
    const [applePayload, setApplePayload] = useState({
        paymentData: {
          // number: null,
          // amount: 30,
          bill_payment_data: [
            { 
              amount: 0, 
              number: null, 
              invoice_no: null,
              contract_number: null
            }
          ]
        },
        apiEndpoint: {
          endpoint: "/terminated_customer/online_bills_payment_apple_pay",
          // endpoint: "/postpaid_bills/pay_with_apple_web",
          successURL: "/join/#/confirmation-apple-bill-payment",
          failureURL: "/join/#/apple-pay-bill-payment-failure",
          method: "post"
        },
        extraInformation: {
        totalAmount: 0,
        payingFor: "bill_payment",
        showAppDownloads: false,
        showPaymentLogos: false,
        }
    });

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        subscriptions.push(
        Translations.getKeysObsrv().subscribe((data) => {
            setTranslationsKeys(data);
        })
        );
        const firebase_event_params = {
            event_category: 'bills',
            event_screen: 'bill_accounts',
            interaction_type: 'view',
            event_label: 'screen'
        }
        FirebaseAnalytics.commonFunction(firebase_event_params);

        return () => {
        if (subscriptions && subscriptions?.length) {
            for (let subscription of subscriptions) {
            subscription.unsubscribe();
            }
        }
        };
    }, []);

    useEffect(() => {
      let realResponse = props?.apiResponse || [];
      let paymentAccountData = Storage.get("paymentAccountData", true);
      if(paymentAccountData) {
        paymentAccountData = JSON.parse(paymentAccountData);
        let overRideResponse = realResponse;
        const updatedSelectedResponse = overRideResponse.reduce((acc, item) => {
          const updatedRecord = paymentAccountData.find(
            u => u.number === item.msisdn
          );
        
          if (updatedRecord) {
            acc.push({
              ...item,
              amount: updatedRecord.amount,
              receiptNumber: updatedRecord.invoice_no,
              contractNumber: updatedRecord.contract_number,
              selected: true,
              valid: true,
            });
          }
        
          return acc;
        }, []);
        const updatedApiResponse = overRideResponse.map(item => {
        const updatedRecord = paymentAccountData.find(
          u => u.number === item.msisdn
        );
      
        // if found, update fields
        if (updatedRecord) {
          return {
            ...item,
            amount: updatedRecord.amount,
            receiptNumber: updatedRecord.invoice_no,
            contractNumber: updatedRecord.contract_number,
            selected: true,
            valid: true,
          };
        }

        // otherwise return original item
        return item;
      });

      const transformedAmount = transformData(updatedSelectedResponse);

      // ✅ Calculate total amount
      const totalAmount = updatedSelectedResponse.reduce(
        (sum, acc) => Number(sum) + Number(acc.amount),
        0
      );
  
      // ✅ Check if pay should be disabled
      const isPayDisabled =
      updatedSelectedResponse.length === 0 || updatedSelectedResponse.some((acc) => !acc.valid);
  
      finalAmount(
        transformedAmount,
        totalAmount,
        isPayDisabled
      );
  
        setApiResponse(updatedApiResponse);
        setSelectedAccounts(updatedSelectedResponse);
        
      } else {
        setApiResponse(realResponse);
      }

    }, [props])

    const showPaymentOnly = (data) => {
        setShowPayment(data);
    }

    const selectedPaymentMethod = (data) => {
        if(data === CONSTANTS.PAYMENT_METHOD_TAP) {
        // const firebase_event_params = {
        //     event_category: 'bills',
        //     event_screen: 'bills_details',
        //     interaction_type: 'click',
        //     event_label: 'pay_online',
        //     bill_number: tapPayload?.paymentData?.number || '',
        //     bill_amount: tapPayload?.paymentData?.amount || '',
        //     payment_amount: amountFormValues?.amount?.value || ''
        // }
        // FirebaseAnalytics.commonFunction(firebase_event_params);
        }else{
        const firebase_event_params = {
            event_category: 'bills',
            event_screen: 'bills_details',
            interaction_type: 'click',
            event_label: 'apple_pay',
            bill_number: '',
            bill_amount: '',
            payment_amount: applePayload?.extraInformation?.totalAmount || ''
        }
        FirebaseAnalytics.commonFunction(firebase_event_params);
        }
        Storage.set("SelectedPaymentMethodTemp", data);
    }

    const transformData = (data) => {
      return {
        bill_payment_data: data.map(item => ({
          amount: item.amount,
          number: item.msisdn,
          invoice_no: item.receiptNumber,
          contract_number: item.contractNumber
        }))
      };
    }

    const selectedAccountCall = (account) => {
      setSelectedAccounts((prev) => {
        let updated;
        if (!account.selected) {
          // remove if unchecked
          updated = prev.filter((item) => item.msisdn !== account.msisdn);
        } else {
          const exists = prev.find((item) => item.msisdn === account.msisdn);
          if (exists) {
            // update existing
            updated = prev.map((item) =>
              item.msisdn === account.msisdn ? account : item
            );
          } else {
            // add new
            updated = [...prev, account];
          }
        }
        const transformedAmount = transformData(updated);
        // finalAmount(transformedAmount);

        // ✅ Calculate total amount
        const totalAmount = updated.reduce(
          (sum, acc) => Number(sum) + Number(acc.amount),
          0
        );
    
        // ✅ Check if pay should be disabled
        const isPayDisabled =
          updated.length === 0 || updated.some((acc) => !acc.valid);
    
        finalAmount(
          transformedAmount,
          totalAmount,
          isPayDisabled
        );
        return updated;
      });
    };
    
    const finalAmount = (transformedAmount, totalAmt, payStatus) => {
      setTotalAmount(totalAmt);
      setIsPayDisabled(payStatus);
      setTapPayload((prev) => ({
        ...prev,
        paymentData: transformedAmount,
        extraInformation: {
          totalAmount: totalAmt,
          payingFor: "bill_payment",
          showAppDownloads: true,
          showPaymentLogos: true
        }
      }));
      setApplePayload((prev) => ({
        ...prev,
        paymentData: transformedAmount,
        extraInformation: {
          totalAmount: totalAmt,
          payingFor: "bill_payment",
          showAppDownloads: false,
          showPaymentLogos: false
        }
      }));
    }

    return (
      <>
        <div className="bill-payment-accounts-conatiner">
            {showPayment ? 
              <StorefrontTitle
                  title={translationKeys["stm_enter_card_details_title"] || "Enter your card details"}
                  desc={translationKeys["stm_enter_card_details_desc"] || "Enter Payment Details"}
              /> : 
              <>  
                {apiResponse.length > 1 ?
                <StorefrontTitle
                  title={translationKeys["stm_bill_payment_choose_heading"] || "Choose the lines to pay"}
                  desc={translationKeys["stm_bill_payment_method_choose_desc"] || "Select one or more lines you’d like to pay the bills for"}
                /> : 
                <StorefrontTitle
                  title={translationKeys["stm_bill_payment_heading"] || "Bill payment"}
                  desc={translationKeys["stm_bill_payment_amount_desc"] || "Enter the amount you want to pay"}
                /> 
                }
                <div className="bill-payment-accounts-lists">
                    {apiResponse.map((account, index) => {
                      return <BillPaymentAccountRow key={index} account={account} selectedAccountCall={selectedAccountCall} billCount={apiResponse.length} selectedAccounts={selectedAccounts}/>
                    })}
                </div>
                {apiResponse.length > 1 ?
                <div className="bill-payment-total-acc-amount">
                    <span>{translationKeys["stm_bill_payment_total_amt"] || "Total Amount"}</span>
                    <div>{Helpers.renderCurrencySymbolWithPrice(Helpers.formatWithPORemoveCommas(totalAmount), "SAR")}</div>
                </div> : ""}
              </>
            }
        </div>
        <div className={`bill-payment-accounts-pay-conatiner ${showPayment ? "bill-payment-accounts-pay-conatiner-show" : ""}`}>
          <CommonPayment
            selectedPaymentMethod={(data) => selectedPaymentMethod(data)} 
            showPaymentOnly={(data) => showPaymentOnly(data)} 
            tapPayload={tapPayload}
            applePayload={applePayload}
            paymentDisabled={isPayDisabled}
            uiType={"flatUI"}
            hideAppDownloads={true}
            clickMimick={true}
            history={history}
          />
        </div>
    </>
    )
}
export default BillPaymentAccounts;